export const OPTIONS_YES_NO = [
  { value: 1, label: "SI" },
  { value: 0, label: "NO" },
];

export const OPTIONS_A_B = [
  { label: "A", value: "A" },
  { label: "B", value: "B" },
];
